module.exports = __webpack_public_path__ + "img/1592829739.cca0053c.jpg";